// API请求配置
export const API_CONFIG = {
  // 基础URL
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '/xintong',
  // 超时时间
  TIMEOUT: 10000,
  // 请求头
  HEADERS: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
};

// 请求状态码
export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  ACCEPTED: 202,
  CLIENT_ERROR: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
};

// 响应数据的基础结构
export interface BaseResponse<T = any> {
  code: number;
  data: T;
  message: string;
  token?: string; // token 应该作为可选字段，通常包含在 data 中
}
